/**
 * 검색 박스 레이아웃
 * @param children 하위 컴포넌트
 * @returns 검색 박스 레이아웃
 */
export default function SearchBoxLayout({ children }: { children: React.ReactNode }) {
  return <div className="mx-4 mt-3 mb-4 bg-[#EEEEEE] rounded-sm px-4 py-3">{children}</div>;
}
